import { computed, useRoute, useRuntimeConfig } from '#imports';

export function useCanonical() {
  const route = useRoute();
  const runtime = useRuntimeConfig();

  return computed(() => {
    const base = ((runtime.public.siteUrl || '') as string).trim();
    const url = new URL(base.startsWith('http') ? base : `https://${base}`);
    url.protocol = 'https:';
    url.hostname = url.hostname.replace(/^www\./, '');

    const path = route.path || '/';
    url.pathname = path.endsWith('/') ? path : path + '/';

    url.search = '';
    url.hash = '';
    return url.toString();
  });
}
